import { render, staticRenderFns } from "./CartProductGroup.vue?vue&type=template&id=2bab1aed"
import script from "./CartProductGroup.vue?vue&type=script&lang=js"
export * from "./CartProductGroup.vue?vue&type=script&lang=js"
import style0 from "./CartProductGroup.vue?vue&type=style&index=0&id=2bab1aed&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports